export default "* Minimum 2 trækbårer\n* 2 sten, kegler, flag eller lign.";